import React, { useEffect,  useState } from "react";
import axios from "axios"; 
import VideoModal from "../modal/VideoModal";
import "./SuccessStories.css";

const VideoTestimonials = () => {
    const [videos, setVideos] = useState([]);
    const [openVideoId, setOpenVideoId] = useState(null);

    useEffect(() => {
      // Fetch video data from API
      axios
        .get("https://www.isolsgroup.com/new/api/ApiVideoTestimonial", {
          headers: {
            "X-API-KEY": "ISOLS", // 🔐 Replace with your actual key if required
          },
        })
        .then((response) => {
          if (response.data && Array.isArray(response.data.data)) {
            // ✅ Limit to only first 4 records
            const homepagevideo = response.data.data
              .filter((item) => item.success_story_status === "1" || item.success_story_status === 1)
              .slice(0, 3);
            setVideos(homepagevideo);
          } else {
            console.error("Unexpected API response format:", response.data);
          }
        })
        .catch((error) => {
          console.error("Error fetching video testimonials:", error);
        });
    }, []);

  return (
    <div className="video successstories">
      
        <div className="row">
          {videos.length > 0 ? (
          videos.map((video, index) => (
            <div key={index} className="col-xs-4 col-sm-4">
              <div className="successvideo">
                <iframe
                    width="100%"
                    height="250"
                    src={video.link}
                    frameBorder="0"
                    allowFullScreen
                    title={video.name}
                  ></iframe>
              </div>
            </div>
          ))
        ) : (
          <p className="text-center mt-4">No video available.</p>
        )}
        </div>
      
       <VideoModal
        open={!!openVideoId}
        onClose={() => setOpenVideoId(null)}
        videoId={openVideoId}
      />

    </div>
  );
};

export default VideoTestimonials;
